"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsService = function AnalyticsService(HttpService) {
    "ngInject";

    var getRevenueDataSource = function getRevenueDataSource(successCb) {
        var dataSource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: _env2.default.getApiUrl("analytics/revenue"),
                    contentType: "application/json",
                    type: "GET",
                    beforeSend: _onBeforeSend

                }
                // parameterMap: _parameterMap
            },
            change: successCb,
            schema: {
                data: function data(response) {
                    return response.series[0].data;
                },
                model: {
                    id: "id",
                    fields: {
                        "date": { type: "date" },
                        "revenue": {}
                    }
                }
            }
        });

        return dataSource;
    };

    // const getRevenueData = (successCb, failureCb) => {
    //     HttpService.get("analytics/revenue", successCb, failureCb);
    // }

    // const getPayingCustomersData = (successCb, failureCb) => {
    //     HttpService.get("analytics/payingcustomers", successCb, failureCb);
    // }

    // const getJobsSuccessRateData = (successCb, failureCb) => {
    //     HttpService.get("analytics/jobssuccessrate", successCb, failureCb);
    // }

    var getRevenueData = function getRevenueData() {
        return HttpService.getPromise("analytics/revenue");
    };

    var getMonthlyRevenueData = function getMonthlyRevenueData() {
        return HttpService.getPromise("analytics/nmrrevenue");
    };

    var getRevenueYearOverYearData = function getRevenueYearOverYearData() {
        return HttpService.getPromise("analytics/revenueyoy");
    };

    var getRevenueFinancialYearOverYearData = function getRevenueFinancialYearOverYearData() {
        return HttpService.getPromise("analytics/revenuefyoy");
    };

    var getRevenueFinancialYearOverYearBreakdownData = function getRevenueFinancialYearOverYearBreakdownData() {
        return HttpService.getPromise("analytics/revenuefyoybreakdown");
    };

    var getRevenueBreakdownData = function getRevenueBreakdownData() {
        return HttpService.getPromise("analytics/revenuebreakdown");
    };

    var getBusinessRevenueBreakdownData = function getBusinessRevenueBreakdownData() {
        return HttpService.getPromise("analytics/businessrevenuebreakdown");
    };

    var getHelperRevenueBreakdownData = function getHelperRevenueBreakdownData() {
        return HttpService.getPromise("analytics/helperrevenuebreakdown");
    };

    var getNewRevenueBreakdownData = function getNewRevenueBreakdownData() {
        return HttpService.getPromise("analytics/newrevenuebreakdown");
    };

    var getAccountRatingsBreakdownData = function getAccountRatingsBreakdownData() {
        return HttpService.getPromise("analytics/accountratingsovertime");
    };

    var getRevenueByStateData = function getRevenueByStateData() {
        return HttpService.getPromise("analytics/revenuebystate");
    };

    var getNzRevenueByRegionData = function getNzRevenueByRegionData() {
        return HttpService.getPromise("analytics/nzrevenuebyregion");
    };

    var getPayingCustomersOvertimeData = function getPayingCustomersOvertimeData() {
        return HttpService.getPromise("analytics/payingcustomersovertime");
    };

    var getUpsellBreakdown = function getUpsellBreakdown() {
        return HttpService.getPromise("analytics/upsellBreakdown");
    };

    var getAvgTrnValueData = function getAvgTrnValueData() {
        return HttpService.getPromise("analytics/avgtrnvalue");
    };

    var getRefundsData = function getRefundsData() {
        return HttpService.getPromise("analytics/refunds");
    };

    var getRefundsAmountData = function getRefundsAmountData() {
        return HttpService.getPromise("analytics/refundscount");
    };

    var getClientRefundsData = function getClientRefundsData() {
        return HttpService.getPromise("analytics/clientrefunds");
    };

    var getRecentRevenueData = function getRecentRevenueData() {
        return HttpService.getPromise("analytics/recentrevenue");
    };

    var getRecentRevenueByDeviceData = function getRecentRevenueByDeviceData() {
        return HttpService.getPromise("analytics/recentrevenuebydevice");
    };

    var getRevenueByDeviceData = function getRevenueByDeviceData() {
        return HttpService.getPromise("analytics/revenuebydevice");
    };

    var getDataSets = function getDataSets() {
        return HttpService.getPromise("analytics/datasets");
    };

    var getJobValueOverTimeData = function getJobValueOverTimeData() {
        return HttpService.getPromise("analytics/jobsvalueovertime");
    };

    var getJobValueByFinancialYearData = function getJobValueByFinancialYearData() {
        return HttpService.getPromise("analytics/jobsvaluebyfinancialyear");
    };

    var getPayingCustomersData = function getPayingCustomersData() {
        return HttpService.getPromise("analytics/payingcustomers");
    };

    var getCustomerRedemptionsOverTime = function getCustomerRedemptionsOverTime() {
        return HttpService.getPromise("analytics/customerredemptionsovertime");
    };

    var getRegistrationsOverTimeData = function getRegistrationsOverTimeData() {
        return HttpService.getPromise("analytics/registrationsovertime");
    };

    var getRegistrationsYearOverYearData = function getRegistrationsYearOverYearData() {
        return HttpService.getPromise("analytics/registrationsyoy");
    };

    var getRegistrationsFinancialYearOverYearData = function getRegistrationsFinancialYearOverYearData() {
        return HttpService.getPromise("analytics/registrationsfyoy");
    };

    var getNSWRegistrationsByRegionOverTimeData = function getNSWRegistrationsByRegionOverTimeData() {
        return HttpService.getPromise("analytics/nswregistrationsbyregionovertime");
    };

    var getNZRegistrationsByRegionOverTimeData = function getNZRegistrationsByRegionOverTimeData() {
        return HttpService.getPromise("analytics/nzregistrationsbyregionovertime");
    };

    var getVICRegistrationsByRegionOverTimeData = function getVICRegistrationsByRegionOverTimeData() {
        return HttpService.getPromise("analytics/vicregistrationsbyregionovertime");
    };

    var getQLDRegistrationsByRegionOverTimeData = function getQLDRegistrationsByRegionOverTimeData() {
        return HttpService.getPromise("analytics/qldregistrationsbyregionovertime");
    };

    var getRecentRegistrationsData = function getRecentRegistrationsData() {
        return HttpService.getPromise("analytics/recentregistrations");
    };

    var getRecentAppDownloadsData = function getRecentAppDownloadsData() {
        return HttpService.getPromise("analytics/recentappdownloads");
    };

    var getTopRegistrationsData = function getTopRegistrationsData() {
        return HttpService.getPromise("analytics/topregistrations");
    };

    var getTopRevenueData = function getTopRevenueData() {
        return HttpService.getPromise("analytics/toprevenue");
    };

    var getRegistrationsByStateData = function getRegistrationsByStateData() {
        return HttpService.getPromise("analytics/registrationsbystate");
    };

    var getRecentNSWRegistrationsData = function getRecentNSWRegistrationsData() {
        return HttpService.getPromise("analytics/recentnswregistrations");
    };

    var getRecentVICRegistrationsData = function getRecentVICRegistrationsData() {
        return HttpService.getPromise("analytics/recentvicregistrations");
    };

    var getRecentQLDRegistrationsData = function getRecentQLDRegistrationsData() {
        return HttpService.getPromise("analytics/recentqldregistrations");
    };

    var getJobsSuccessRateData = function getJobsSuccessRateData() {
        return HttpService.getPromise("analytics/jobssuccessrate");
    };

    var getAccountApprovalOverTime = function getAccountApprovalOverTime() {
        return HttpService.getPromise("analytics/accountapprovalovertime");
    };

    var getNewVersusRecurringRevenueData = function getNewVersusRecurringRevenueData() {
        return HttpService.getPromise("analytics/newvsrecurringrevenue");
    };

    var getHelperNewVersusRecurringRevenueData = function getHelperNewVersusRecurringRevenueData() {
        return HttpService.getPromise("analytics/helpernewvsrecurringrevenue");
    };

    var getGeneralStatsData = function getGeneralStatsData() {
        return HttpService.getPromise("analytics/generalstats");
    };

    var getBotStatsData = function getBotStatsData() {
        return HttpService.getPromise("analytics/botstats");
    };

    var getClientProfileItemsPerYearData = function getClientProfileItemsPerYearData() {
        return HttpService.getPromise("analytics/clientprofileitemsperyear");
    };

    var getProviderProfileItemsPerYearData = function getProviderProfileItemsPerYearData() {
        return HttpService.getPromise("analytics/providerprofileitemsperyear");
    };

    var getMonthlyActiveUsersData = function getMonthlyActiveUsersData() {
        return HttpService.getPromise("analytics/monthlyactiveusers");
    };

    var getArruData = function getArruData() {
        return HttpService.getPromise("analytics/arpu");
    };

    var formatRevenueData = function formatRevenueData(data) {
        var revenueData = [];
        var categories = [];
        var seriesArr = data.series;

        seriesArr.map(function (item, index) {

            if (categories.length == 0) {
                item.data.map(function (categoryItem) {
                    categories.push(categoryItem.data);
                });
            }

            revenueData[index] = {
                name: item.name,
                data: item.data,
                field: "revenue",
                // categoryField: "date",
                // labels: {
                //     visible: true,
                //     format: "{0:C}"
                // },
                tooltip: {
                    visible: true,
                    background: "#60686e",
                    format: "{0:C}"
                }
            };
        });

        return {
            series: [revenueData[0]],
            categoryAxis: {
                categories: categories,
                title: {
                    text: "Weeks"
                },
                labels: {
                    format: "MMM"
                },
                baseUnit: "weeks",
                field: "date"
            }
        };
    };

    var getColumnChartOptions = function getColumnChartOptions(title, data) {
        return {
            title: {
                text: title
            },
            theme: "silver",
            legend: {
                position: "top"
            },
            seriesDefaults: {
                type: "column"
            },
            series: data.series,
            valueAxis: {
                labels: {
                    format: "{0:p0}"
                },
                line: {
                    visible: false
                },
                axisCrossingValue: 0,
                max: 1
            },
            categoryAxis: {
                categories: data.categories,
                labels: {
                    template: "#= kendo.toString(new Date(value), 'yyyy') #"
                },
                line: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                format: "{0}%",
                template: "#= series.name #: #= kendo.toString(value, 'p') #"
            }
        };
    };

    var getFunnelChartOptions = function getFunnelChartOptions(title, data, percentageTemplate) {
        return {
            title: {
                text: title,
                position: "bottom"
            },
            theme: "silver",
            legend: {
                visible: false,
                position: "bottom"
            },
            seriesDefaults: {
                labels: {
                    visible: true,
                    background: "transparent",
                    position: "center",
                    template: "#= category #"
                    //color:"white",
                    //format: "N0"
                },
                dynamicSlope: false,
                dynamicHeight: false
            },
            series: [{
                type: "funnel",
                data: data
            }],
            tooltip: {
                visible: true,
                template: percentageTemplate
            }
        };
    };

    var getDonutChartOptions = function getDonutChartOptions(set, titleFormat, labelFormat) {
        return {
            title: {
                text: titleFormat,
                position: "bottom"
            },
            theme: "silver",
            legend: {
                visible: false,
                position: "bottom"
            },
            seriesDefaults: {
                startAngle: 150,
                labels: {
                    visible: true,
                    background: "transparent",
                    position: "outsideEnd",
                    template: labelFormat
                }
            },
            series: [{
                type: "donut",
                field: "percentage",
                categoryField: "category",
                data: set.data
            }],
            tooltip: {
                visible: false
            }
        };
    };

    var getPercentage = function getPercentage(entry) {
        var dataItem = entry.dataItem;
        if (entry.index > 0) {
            var prevDataItem = entry.series.data[entry.index - 1];
            return kendo.format("{0:P} of '{1}' become '{2}', {3:P} of Total Accounts", dataItem.percentage, prevDataItem.category, dataItem.category, dataItem.percentageFromTotal);
        } else {
            return kendo.format("{0:P} of Total Accounts", dataItem.percentage);
        }
    };

    var getGridOptions = function getGridOptions(set) {
        var data = set.data;
        var columns = set.dataInfo;
        columns[0].width = "250px";

        return {
            dataSource: {
                data: data,
                pageable: false
            },
            columns: columns,
            scrollable: false,
            sortable: false,
            filterable: false
        };
    };

    var getChartOptions = function getChartOptions(title, series, categories, format, template, dateFormat, tooltipTemplate, categoryBaseUnit) {
        var tooltipFormatter = void 0;
        if (typeof tooltipTemplate == "function") {
            tooltipFormatter = tooltipTemplate;
        } else {
            if (!tooltipTemplate) tooltipTemplate = "n0";

            tooltipFormatter = function tooltipFormatter(args) {
                var date = kendo.toString(new Date(args.category), dateFormat && dateFormat.days ? dateFormat.days : "MMM yyyy");
                return date + ' - ' + kendo.toString(args.value, tooltipTemplate);
            };
        }

        return {
            title: {
                text: title
            },
            theme: "silver",
            seriesDefaults: {
                type: "line",
                labels: {
                    visible: true,
                    format: format
                }
            },
            series: series,
            legend: {
                position: "bottom",
                labels: {
                    template: template
                }
            },
            tooltip: {
                visible: true,
                background: "#60686e",
                format: format,
                template: tooltipFormatter
            },
            valueAxis: {
                labels: {
                    format: format
                }
            },
            categoryAxis: {
                type: "date",
                categories: categories,
                baseUnit: categoryBaseUnit,
                labels: {
                    visible: true,
                    dateFormats: dateFormat
                }
            }
        };
    };

    return { getRevenueDataSource: getRevenueDataSource, getRevenueBreakdownData: getRevenueBreakdownData, getNewRevenueBreakdownData: getNewRevenueBreakdownData, getRefundsData: getRefundsData, getRefundsAmountData: getRefundsAmountData, getClientRefundsData: getClientRefundsData, getPayingCustomersData: getPayingCustomersData, getRevenueData: getRevenueData, getRecentRevenueData: getRecentRevenueData, getRecentRevenueByDeviceData: getRecentRevenueByDeviceData,
        getRevenueByDeviceData: getRevenueByDeviceData, formatRevenueData: formatRevenueData, getJobsSuccessRateData: getJobsSuccessRateData, getRegistrationsOverTimeData: getRegistrationsOverTimeData, getNSWRegistrationsByRegionOverTimeData: getNSWRegistrationsByRegionOverTimeData, getVICRegistrationsByRegionOverTimeData: getVICRegistrationsByRegionOverTimeData, getNZRegistrationsByRegionOverTimeData: getNZRegistrationsByRegionOverTimeData, getUpsellBreakdown: getUpsellBreakdown,
        getRecentRegistrationsData: getRecentRegistrationsData, getRecentNSWRegistrationsData: getRecentNSWRegistrationsData, getRecentVICRegistrationsData: getRecentVICRegistrationsData, getRecentQLDRegistrationsData: getRecentQLDRegistrationsData, getCustomerRedemptionsOverTime: getCustomerRedemptionsOverTime, getRegistrationsYearOverYearData: getRegistrationsYearOverYearData, getRegistrationsFinancialYearOverYearData: getRegistrationsFinancialYearOverYearData,
        getAccountApprovalOverTime: getAccountApprovalOverTime, getNewVersusRecurringRevenueData: getNewVersusRecurringRevenueData, getGeneralStatsData: getGeneralStatsData, getBotStatsData: getBotStatsData, getRevenueYearOverYearData: getRevenueYearOverYearData, getRevenueFinancialYearOverYearData: getRevenueFinancialYearOverYearData, getQLDRegistrationsByRegionOverTimeData: getQLDRegistrationsByRegionOverTimeData, getRevenueByStateData: getRevenueByStateData, getNzRevenueByRegionData: getNzRevenueByRegionData,
        getClientProfileItemsPerYearData: getClientProfileItemsPerYearData, getProviderProfileItemsPerYearData: getProviderProfileItemsPerYearData, getJobValueOverTimeData: getJobValueOverTimeData, getDataSets: getDataSets, getRegistrationsByStateData: getRegistrationsByStateData, getAvgTrnValueData: getAvgTrnValueData, getPayingCustomersOvertimeData: getPayingCustomersOvertimeData, getRevenueFinancialYearOverYearBreakdownData: getRevenueFinancialYearOverYearBreakdownData,
        getColumnChartOptions: getColumnChartOptions, getFunnelChartOptions: getFunnelChartOptions, getDonutChartOptions: getDonutChartOptions, getGridOptions: getGridOptions, getPercentage: getPercentage, getChartOptions: getChartOptions, getTopRegistrationsData: getTopRegistrationsData, getTopRevenueData: getTopRevenueData, getMonthlyRevenueData: getMonthlyRevenueData, getHelperRevenueBreakdownData: getHelperRevenueBreakdownData,
        getMonthlyActiveUsersData: getMonthlyActiveUsersData, getArruData: getArruData, getJobValueByFinancialYearData: getJobValueByFinancialYearData, getRecentAppDownloadsData: getRecentAppDownloadsData, getAccountRatingsBreakdownData: getAccountRatingsBreakdownData, getHelperNewVersusRecurringRevenueData: getHelperNewVersusRecurringRevenueData, getBusinessRevenueBreakdownData: getBusinessRevenueBreakdownData
    };
};

function _onBeforeSend(req) {
    var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

    req.setRequestHeader("Authorization", token);
}

exports.default = AnalyticsService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/analytics.service.js
 **/